/**
 * Domain Entity: TrendingItem
 * Represents a trending search item.
 */
export class TrendingItem {
  name: string;
  url: string;

  constructor({ name, url }: { name: string; url: string }) {
    this.name = name;
    this.url = url;
  }
}

/**
 * Domain Entity: Product
 * Represents a product in search results.
 */
export class Product {
  image: string;
  name: string;
  url: string;
  designId?: string;

  constructor({
    image,
    name,
    url,
    designId,
  }: {
    image: string;
    name: string;
    url: string;
    designId?: string;
  }) {
    this.image = image;
    this.name = name;
    this.url = url;
    this.designId = designId;
  }
}

/**
 * Domain Entity: Suggestion
 * Represents a search suggestion item.
 */
export class Suggestion {
  title: string;

  constructor({ title }: { title: string }) {
    this.title = title;
  }
}

/**
 * Domain Entity: SearchResults
 * Represents the complete search results including trending, suggestions, and products.
 */
export class SearchResults {
  trending?: {
    list: TrendingItem[];
    trendingTitle: string;
  };
  suggestions: (string | Suggestion)[];
  products: {
    productTitle: string;
    list: Product[];
  };
  searchText?: string;

  constructor({
    trending,
    suggestions,
    products,
    searchText,
  }: {
    trending?: { list: TrendingItem[]; trendingTitle: string };
    suggestions: (string | Suggestion)[];
    products: { productTitle: string; list: Product[] };
    searchText?: string;
  }) {
    this.trending = trending;
    this.suggestions = suggestions;
    this.products = products;
    this.searchText = searchText;
  }
}
